import { type FetchNextPageOptions, type InfiniteQueryObserverResult } from "@tanstack/react-query";

export type AdminSearchTabValue = "agents" | "workplaces" | "all";

export const ADMIN_SEARCH_TAB_OPTIONS = ["agents", "workplaces", "all"] as const;

export const ADMIN_SEARCH_TAB_STORAGE_KEY = "admin-search-tab-selection";

export const ADMIN_SEARCH_TAB_LABELS: Record<AdminSearchTabValue, string> = {
  agents: "Agents",
  workplaces: "Workplaces",
  all: "All",
};

export const ADMIN_SEARCH_PLACEHOLDER =
  "Enter an agent or workplace ID, name, email, or phone number to search";

export interface AccountSwitcherUser {
  type: "AGENT" | "WORKPLACE";
  userId: string;
  name: string;
  title: string;
  subtitles?: string[];
  stage?: string;
}

export interface UserDetails {
  list: AccountSwitcherUser[];
  loading: boolean;
  fetchNextPage?: (options?: FetchNextPageOptions | undefined) => Promise<
    InfiniteQueryObserverResult<{
      list: unknown[];
    }>
  >;
  isFetchingNextPage?: boolean;
  hasNextPage?: boolean;
}
